module.exports = __webpack_public_path__ + "img/定兴礼帽.5281f07a.jpg";